import React from "react";

interface AboutProps {
  data?: { paragraph: string; Why: string[]; Why2: string[] };
}

export const About: React.FC<AboutProps> = ({ data }) => {
  const reasons = [...(data?.Why ?? []), ...(data?.Why2 ?? [])];

  return (
    <section id="personalizacao" className="relative py-24">
      <div className="absolute inset-0 -z-10 bg-white/70" />
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-6 lg:grid-cols-2 lg:px-8">
        <div className="relative">
          <img
            src="/img/about.jpg"
            alt="Equipe colaborando com apoio da tecnologia"
            className="relative w-full rounded-3xl border border-white/80 shadow-soft"
          />
        </div>
        <div className="rounded-3xl border border-slate-200/70 bg-white/90 p-8 shadow-soft">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-red-600">
            Feita para a sua realidade
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-slate-900">
            Um agente preparado para trabalhar do jeito da sua empresa
          </h2>
          <p className="mt-4 text-slate-600">
            {data?.paragraph ?? "loading..."}
          </p>
          <h3 className="mt-8 text-xl font-semibold text-slate-900">
            Personalização com controle
          </h3>
          <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {reasons.map((text, index) => (
              <li
                key={index}
                className="flex items-start gap-3 rounded-xl border border-slate-100 bg-slate-50/80 p-3 text-sm text-slate-600"
              >
                <span className="mt-1 h-2 w-2 rounded-full bg-cyan-500" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
